













































































import Vue from "vue";
import Component from "vue-class-component";
@Component
export default class UploadSurvey extends Vue {
  surveyData: any = {};
  surveyDataForDisplay: string = "";
  hasError: boolean = false;
  format: boolean = false;
  errorMessage = "";

  $refs!: {
    fileUpload: HTMLInputElement;
  };

  showUploadSurveyDialog() {
    this.$bvModal.show("load-loacal-survey-modal");
  }

  uploadSurveyData(): void {
    if (!(!!this.surveyData && !!this.surveyData.name)) {
      this.hasError = true;
      this.errorMessage = "validation.file.required";
      return;
    }
    this.$emit("surveyDataLoaded", this.surveyData);
    this.$bvModal.hide("load-loacal-survey-modal");
  }

  cancel() {
    this.$bvModal.hide("load-loacal-survey-modal");
  }

  selectFile(event: MouseEvent) {
    document.getElementById("fileInput")?.click();
  }

  onFileChanged($event: any) {
    if (
      $event === null ||
      $event.target === null ||
      $event.dataTransfer === null
    ) {
      return;
    }

    const target = $event.target as HTMLInputElement;
    const files = target.files || $event.dataTransfer.files;

    if (files.length === 0) {
      return;
    }
    this.loadSurveyFromFile(files[0]);
  }

  onToggleFormat() {
    if (this.surveyData && this.surveyData.name) {
      this.surveyDataForDisplay = this.format
        ? JSON.stringify(this.surveyData, null, 4)
        : JSON.stringify(this.surveyData);
    }
  }

  loadSurveyFromFile(file: any) {
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent) => {
      const result = reader.result as string;
      if (result === "undefined") {
        this.hasError = true;
        this.errorMessage = "validation.file.format";
        this.$refs.fileUpload.value = "";
        this.surveyData = {
          fileName: file.name,
          hasError: true,
          errorMessage: "validation.file.format"
        };
        this.surveyDataForDisplay = "";
        return;
      }
      try {
        this.surveyData = JSON.parse(result);
        this.surveyData.fileName = file.name;
        this.surveyDataForDisplay = this.format
          ? JSON.stringify(this.surveyData, null, 4)
          : JSON.stringify(this.surveyData);
        this.errorMessage = "";
        this.hasError = false;
      } catch (e) {
        this.$refs.fileUpload.value = "";
        this.surveyData = {
          fileName: file.name,
          hasError: true,
          errorMessage: "validation.file.format"
        };
        this.surveyDataForDisplay = "";
        this.hasError = true;
        this.errorMessage = "validation.file.format";
      }
    };
    reader.readAsText(file);
  }
}
